import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FieldLabel = styled.span`
  font-size: var(--font-size-sm, 0.875rem);
  line-height: var(--line-height-size-default, 1.375rem);
  color: ${({ theme }) => theme.colors.grayDark4};
  padding: 0 var(--spacing-size-sm, 0.5rem);
  margin-bottom: 0.25rem;
`;

export const Trigger = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  border: 0.063rem solid var(--secondary-color-01-200, #9e9e9e);
  border-radius: var(--border-radius-md, 4px);
  padding: var(--spacing-size-md, 0.75rem) var(--spacing-size-md, 0.75rem);
  min-height: 3rem;
  background: ${({ disabled, theme }) =>
    disabled ? theme.colors.gray8 : theme.colors.white};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};

  &:hover {
    border-color: ${({ disabled }) =>
      disabled
        ? 'var(--secondary-color-01-200, #9e9e9e)'
        : 'var(--primary-color-02-600, #0069ac)'};
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: 0.125rem;
`;

export const BpName = styled.span<{ isEmpty?: boolean }>`
  font-family: 'Work Sans';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.grayDark4};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BpAddress = styled.span`
  font-family: 'Work Sans';
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.grayDark4};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CaretWrapper = styled.div<{ disabled?: boolean }>`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.blue6};

  svg {
    color: ${({ disabled, theme }) =>
      disabled ? theme.colors.grayDark4 : theme.colors.blue6};
  }
`;
